module.exports = __webpack_public_path__ + "img/1726037326805-screenshot-1726037306378.png.90e1f9e5.webp";